import { lazy } from "react";

// Lazy loading для пользовательских страниц (БЕЗ лендинга)
export const QuickStartPage = lazy(() => import("../pages/QuickStartPage"));
export const AuthPage = lazy(() => import("../pages/AuthPage"));
export const EmailVerificationPage = lazy(
  () => import("../pages/EmailVerificationPage"),
);
export const Dashboard = lazy(() => import("../pages/Dashboard"));
export const ProfilePage = lazy(() => import("../pages/ProfilePage"));
export const AnonymousSettingsPage = lazy(
  () => import("../pages/AnonymousSettingsPage"),
);
export const SubscriptionPage = lazy(() => import("../pages/SubscriptionPage"));
export const UserSubscriptionPage = lazy(
  () => import("../pages/UserSubscriptionPage"),
);
export const PracticePage = lazy(() => import("../pages/PracticePage"));
export const DictationPage = lazy(() => import("../pages/DictationPage"));
export const DictationSessionPage = lazy(
  () => import("../pages/DictationSessionPage"),
);
export const StripeSuccessPage = lazy(
  () => import("../pages/StripeSuccessPage"),
);
export const StripeCancelPage = lazy(() => import("../pages/StripeCancelPage"));

// Dictionary pages
export const DictionaryPage = lazy(
  () => import("../features/dictionary/pages/DictionaryPage"),
);
export const AdaptiveStudyPage = lazy(
  () => import("../features/dictionary/pages/AdaptiveStudyPage"),
);
export const WordsPage = lazy(
  () => import("../features/dictionary/pages/WordsPage"),
);

// Lazy loading для компонентов авторизации
export const MultiStepRegistrationContainer = lazy(() =>
  import("../features/auth").then((module) => ({
    default: module.MultiStepRegistrationContainer,
  })),
);
